import { createEvent } from 'effector'

/** Clears cached Movies genres and languages when preferred region changes. */
export const resetContentOnPreferredRegionChange = createEvent()
